import React from "react";
import { ConfigProvider, Layout } from "antd";
import { Outlet } from "react-router-dom";
import AdminHeader from "./adminHeader";
import AdminSideMenu from "./adminSideMenu";
import "css/admin/admin.global.css";

function AdminLayout() {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Pretendard",
          fontFamilyCode: "Pretendard",
        },
      }}
    >
      <Layout className="adminRoot" style={{ minHeight: "100vh" }}>
        <AdminHeader />
        <Layout style={{ minHeight: `calc(100vh - 75px)` }}>
          <AdminSideMenu />
          <Layout.Content
            style={{
              padding: "35px 30px",
              background: "#f6f7f9",
              overflowX: "auto",
              scrollbarGutter: "stable",
            }}
          >
            <div style={{ minWidth: 1550 }}>
              <Outlet />
            </div>
          </Layout.Content>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
}

export default AdminLayout;
